export enum TrackingProviderTypeEnum {
    GPS = 'gps',
    INTEGRATION = 'integration',
    /** No auth config of its own: the real connection is managed by another platform (e.g. the SaaS). */
    SAAS = 'saas',
}
